import { apiClient } from "./apiClient";

/**
 * GAP: app.ThemeUsageAnalytics (V016) already has per-user
 * activation_date/upgrade_date/downgrade_date columns, which is exactly
 * what a real Basic->Advanced funnel, time-to-upgrade average, and common
 * migration-path breakdown would aggregate -- but no endpoint does that
 * aggregation today. admin.py's existing upgrade-funnel endpoint queries a
 * *different* table (app.UserSubscriptionLogs, Free/Standard/AI tier
 * changes) and is used for Subscription Analytics instead (see
 * adminApi.upgradeFunnel). These three calls are the theme-specific
 * equivalent, still unbuilt.
 */
export const themeAnalyticsApi = {
  upgradeFunnel: () => apiClient.get("/management/analytics/theme-upgrade-funnel").then((r) => r.data),
  timeToUpgrade: () => apiClient.get("/management/analytics/theme-time-to-upgrade").then((r) => r.data),
  migrationPaths: () => apiClient.get("/management/analytics/theme-migration-paths").then((r) => r.data),
};
